/* eslint-disable no-use-before-define, consistent-return, default-case */

export type SidebarAppearance = 'link' | 'highlighted';

export interface SidebarList {
  type: 'list';
  key: string; // Name of the directory, e.g. "messaging"
  icon?: string;
  iconColor?: string;
  collapsible?: boolean;
  tag?: string;
  children: SidebarNode[];
}

export interface SidebarItem {
  type: 'item';
  key: string; // Name of the file without extension, e.g. "api-reference"
  href: string; // without language, e.g. "/voice/overview", or a full URL
  title?: string;
  appearance?: SidebarAppearance;
  icon?: string;
  tag?: string;
}

export const pathMatches = (item: SidebarItem, path: string): boolean => {
  const urlWithoutQueryParams = item.href.split('?')[0];
  return decodeURIComponent(path) === urlWithoutQueryParams || path.startsWith(`${urlWithoutQueryParams}/`);
};
export type SidebarNode = SidebarList | SidebarItem;

export const pathMatchesPreviousPath = (node: SidebarNode, path: string, prevPath: string): boolean => {
  if (path && !path.startsWith(`${prevPath}/`)) return false;
  if (node.type == 'list')
    return node.children.some(child => pathMatchesPreviousPath(child, path, prevPath + '/' + node.key));
  return true;
};

export const pathMatchesAnyChild = (node: SidebarNode, path: string): boolean => {
  switch (node.type) {
    case 'item':
      return pathMatches(node, path);
    case 'list':
      return node.children.some(child => pathMatchesAnyChild(child, path));
  }
};

export const isPathMatching = (data: SidebarNode, path: string) => pathMatchesAnyChild(data, path);
